import{jsx as e}from"react/jsx-runtime";import o,{keyframes as t}from"styled-components";import{theme as a}from"../../../theme.js";const r=20,n=t`
  0% {
    transform: rotate(0deg);
  }
  50%{
    transform: rotate(540deg);
  }
  100% {
    transform: rotate(1080deg);
  }
`,i=t`
  0% {
    stroke-dashoffset: ${r*.5};
  }
  50% {
    stroke-dashoffset: ${r*3.14};
  }
  100% {
    stroke-dashoffset: ${r*.5};
  }
`,s=o.svg`
  circle {
    fill: transparent;
    stroke: ${a.colors.shades[0]};
    stroke-width: 2;
    stroke-linecap: round;
    stroke-dasharray: ${r*3.14}px;
    stroke-dashoffset: -10;
    transform-origin: 50% 50%;
    animation: ${n} 3s linear infinite, ${i} 2.5s linear infinite;
  }
`,f=()=>e(s,{"data-testid":"spinner",viewBox:"0 0 20 20",x:"0",y:"0",className:"spinner",children:e("circle",{cx:"10",cy:"10",r:"8"})});export{f as Spinner,s as SpinnerWrapper};
